import { Skeleton } from "@/components/ui/skeleton";
import { EmptyState } from "@/components/shared/empty-state";
import { ReviewCard } from "@/features/quarterly-reviews/review-card";
import { CreateReviewDialog } from "@/features/quarterly-reviews/create-review-dialog";
import { useQuarterlyReviews } from "@/hooks/use-quarterly-reviews";
import { useCurrentUser, isSupervisorOrAbove } from "@/hooks/use-current-user";

export function ReviewsPage() {
  const { currentUser } = useCurrentUser();
  const { data, isLoading, error } = useQuarterlyReviews();
  const canCreate = isSupervisorOrAbove(currentUser?.role);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-3xl font-semibold">Quarterly Reviews</h1>
        {canCreate && <CreateReviewDialog />}
      </div>

      {isLoading ? (
        <div className="space-y-3" role="status" aria-label="Loading reviews">
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
          <Skeleton className="h-20 w-full" />
        </div>
      ) : error ? (
        <EmptyState
          title="Failed to load reviews"
          description={error.message}
        />
      ) : !data?.data || data.data.length === 0 ? (
        <EmptyState
          title="No Quarterly Reviews"
          description={
            canCreate
              ? "Create a quarterly review for your direct reports."
              : "Your quarterly reviews will appear here when created by your supervisor."
          }
        />
      ) : (
        <div className="space-y-3">
          {data.data.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>
      )}
    </div>
  );
}
